<ng-container *ngIf="!loadingRow && observation !== undefined">

  <!--<td></td>-->
  <td title="Click to edit Observation" (click)="openSchematicWindow()" class="pointer">
    <div style="display: flex; gap: 20px;">
      <div style="width: 150px;">

      </div>
      <div>
        <span> {{observation?.ComponentName }} </span>
      </div>
    </div>
  </td>
  <td title="Click to edit Observation" (click)="openSchematicWindow()" class="pointer">
    <span> {{observation?.PartNumber }} </span>
  </td>
  <td title="Click to edit Observation" (click)="openSchematicWindow()" class="pointer">
    <span> {{observation?.CNG }} </span>
    <!-- <span> {{observation?.isCritical==true?"Yes":"No" }} </span> -->
  </td>
  <td title="Click to edit Observation" (click)="openSchematicWindow()" class="pointer">
    <span> {{observation?.Cmu}} </span>
  </td>
  <td title="Click to edit Observation" (click)="openSchematicWindow()" class="pointer"><span>{{observation.Residual}}</span></td>
  <!-- <td>
    <span>  {{observation?.CompWorstWorn}} </span>
  </td> -->
  <!-- <td>
    <span> Residual hrs </span>
  </td> -->
  <td title="Click to edit Observation" (click)="openSchematicWindow()" class="pointer">{{observation.ObservationName}} </td>
  <td title="Click to edit Observation" (click)="openSchematicWindow()" class="pointer">{{observation.ObservationTypeName}} </td>
  <td *ngIf="observation.ObservationTypeName =='Evaluation' || observation.ObservationTypeName =='Selection' || observation.ObservationTypeName =='Pass/Fail' || observation.ObservationTypeName =='Yes/No'">N/A </td>
  <td *ngIf="observation.ObservationTypeName !='Evaluation' && observation.ObservationTypeName !='Selection' && observation.ObservationTypeName !='Pass/Fail' && observation.ObservationTypeName !='Yes/No'">
    <div style="display: flex; justify-content: space-between; width: 100%;">
      <div style="width: 50%;">{{observation.LimitNew}}</div>
      <div style="width: 50%;">{{observation.LimitScrap}}</div>
    </div>
  </td>
  <td class="margin-right">
    <div class="observation-question" [class.ShouldHighLight]="shouldHighlight(observation)">
      <i title="Observation Questions" class="material-icons upload-container__icon" (click)="openQPopup()">
        message
      </i>
    </div>
  </td>
  <td>
    <div class="observation-question" [class.ShouldHighLight]="shouldHighlightQandI(observation)">
      <i title="Question Image & Instructions" class="material-icons" (click)="openPopup()">rate_review</i>
    </div>
  </td>
  <td> <measurement-on-observation (measurementChanged)="measurementChanged($event)" [isCreatingInspection]="false" [observationPoint]="observation"></measurement-on-observation> </td>
  <td *ngIf="observation.ObservationTypeId !=3 && observation.ObservationTypeId!=4 && observation.ObservationTypeId!=5 && observation.ObservationTypeId!=6">
    <div class="{{getEvalClass(observation.WornPercentage)}}  worn-percentage">
      {{observation.WornPercentage}} %
    </div>
  </td>
  <td *ngIf="observation.ObservationTypeId ==3 || observation.ObservationTypeId ==4 || observation.ObservationTypeId ==5 || observation.ObservationTypeId ==6">
    <div class="{{getEvalClass2(observation.WornPercentage)}}  worn-percentage">
      {{getEvalCode(observation.WornPercentage)}}
    </div>
  </td>

  <td>
   <mat-form-field style="width: 85%;" *ngIf="observation.ObsList?.length">

  <!-- MULTI for normal observation  -->
  <mat-select
    *ngIf="observation.ObservationTypeName !== 'Crack'"
    [(ngModel)]="observation.severityIDs"
    [ngModelOptions]="{ standalone: true }"
    multiple
    (selectionChange)="updateObsSeverity(observation.Id, observation.severityIDs)">

    <mat-option *ngFor="let list of observation.ObsList" [value]="list.ID">
      {{ list.Name }}
    </mat-option>
  </mat-select>

  <!-- SINGLE for crack normal observation -->
  <mat-select
    *ngIf="observation.ObservationTypeName === 'Crack'"
    [(ngModel)]="observation.obsId"
    [ngModelOptions]="{ standalone: true }"
    (selectionChange)="updateObsSeverity(observation.Id, observation.obsId)">

    <mat-option *ngFor="let list of observation.ObsList" [value]="list.ID">
      {{ list.Name }}
    </mat-option>
  </mat-select>

</mat-form-field>

  </td>
  <td>
    <!-- <mat-form-field style="width: 100px;" *ngIf="observation.obsSeverityList!=null && observation.obsSeverityList.length>0"> *ngIf="observation.ObservationTypeName =='Crack'" -->
    <mat-form-field style="width: 85%;" *ngIf="observation.obsSeverityList?.length && observation.ObservationTypeName =='Crack'">
      <mat-select [(ngModel)]="observation.severityID" (selectionChange)="updateCrackSeverity(observation.Id, observation.severityID)">
        <mat-option *ngFor="let list of observation.obsSeverityList" [value]="list.ID">{{list.Name}}</mat-option>
      </mat-select>
    </mat-form-field>
    <!--<div style="width: 100px;" *ngIf="observation.obsSeverityList.length==0 || observation.obsSeverityList.length==null">
  </div>-->
  </td>

  <td *ngIf="observation.Flag==true" class="pointer"> <i title="Observation Flag" class="material-icons" (click)="ToggleObsFlag(observation.Id,false)" style="color: red;">flag</i></td>
  <td *ngIf="observation.Flag==false" class="pointer"> <i title="Observation Flag" class="material-icons" (click)="ToggleObsFlag(observation.Id,true)">flag</i></td>
  <td>
    <span *ngFor="let image of observation?.ObservationImages">
      <img class="observation-image__photo" (click)="viewObservationImages(image)" *ngIf="image.ImageData !== ''" [src]="getImage(image.ImageData)">
    </span>

    <photos-modal [observationPoint]="observation" [ObservationPointId]="observation.Id" [comingFrom]="photoComingFrom" (onPhotoUpload)="photoRecevied($event, observation)"></photos-modal>
  </td>
  <td>
    <observation-comments #observationComment [observationPoint]="observation" [comingFrom]="commentComingFrom" (onCommentChange)="commentChanged($event,observation)"></observation-comments>
  </td>
  <td class="pointer"><i title="Delete Measurement" class="material-icons" (click)="DeleteObsMeasurement(observation)">delete</i></td>
  <td class="margin-right">
    <mat-checkbox id="chkObservation-{{observation.Id}}" [checked]="observation?.IncludeReport" style="margin-left: 34%;" color="primary"
                  (change)="toggleObservationPointIncludeReport(observation.Id)">
    </mat-checkbox>


  </td>
</ng-container>

<ng-container *ngIf="loadingRow">
  <mat-spinner diameter="34"></mat-spinner>
</ng-container>
<ng-container *ngIf="openingEditPopup">
  <div class="spinner-overlay">
    <mat-spinner diameter="34"></mat-spinner>
  </div>
</ng-container>

<!-- Modal Popup -->
<div *ngIf="showPopup" class="modal-overlay" (click)="closePopup()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="ttmodal__header">
      <span class="ttmodal__title">Question Image & Instructions</span>
      <i class="material-icons ttmodal__close-button" (click)="closePopup()" title="Close">close</i>
    </div>
    <div class="upload-container" style="margin-top: 15px; text-align: center; padding: 20px; min-height: 150px;">
      <!--<input hidden type="file" (change)="onSelectModalImage($event)" #modalImageInput>-->
      <div *ngIf="!observation.Image">
        <i class="material-icons upload-container__icon">add_a_photo</i>
      </div>
      <div *ngIf="observation.Image" style="display: flex; align-items: center; justify-content: center;">
        <img [src]="getImage(observation.Image)" style="width: 60%; height: 60%; margin-right: 5px; cursor: pointer;" />
      </div>
    </div>
    <!--<div style="display: flex; justify-content: end; gap: 10px; margin: 10px 0;">
    <button mat-raised-button class="button button-delete" [disabled]="!selectedQImage" (click)="deleteQuestionimage(selectedId, isNewSelectedQImage)"><i class="material-icons button__icon">delete</i><span>{{'Delete Image' | translate | async}}</span></button>
    <button mat-raised-button color="warn" (click)="modalImageInput.click()"><i class="material-icons button__icon" style="padding-right: 8px;">cloud_upload</i><span>{{'Upload Image' | translate | async}}</span></button>
  </div>-->
  <span class="ttmodal__title">Instructions</span>
    <span [innerText]="observation.QuestionInstruction"
          style="display: inline-block; width: 100%; min-height: 8em; border: 1px solid #ccc; padding: 4px; white-space: pre-wrap; overflow: auto;">
    </span>
    <!--<div style="display: flex; justify-content: end; gap: 10px; margin: 10px 0;">
    <button mat-raised-button class="button button-delete" [disabled]="!selectedQDesc" (click)="deleteQuestionInstruction(selectedId)"><i class="material-icons button__icon">delete</i><span>{{'Delete Comment' | translate | async}}</span></button>
    <button mat-raised-button color="warn" class="save-btn" (click)="saveUpdate()"><i class="material-icons save-button__icon" style="padding-right: 8px;">save</i><span>{{'Save/Update' | translate | async}}</span></button>
  </div>-->
  </div>
</div>

<div *ngIf="showQPopup" class="modal-overlay" (click)="closeQPopup()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="ttmodal__header">
      <span class="ttmodal__title">Question</span>
      <i class="material-icons ttmodal__close-button" (click)="closeQPopup()" title="Close">close</i>
    </div>
    <span [innerText]="observation.QuestionTitle"
          style="display: inline-block; width: 70ch; min-height: 13em; border: 1px solid #ccc; padding: 4px; white-space: pre-wrap; overflow: auto;">
    </span>
  </div>
</div>
